module.exports = __webpack_public_path__ + "img/icon-edit-green.b3fa3198.svg";